import { component } from "picoapp";

export default component((node) => {
  const playElement = node.querySelector("[data-play]");
  const pauseElement = node.querySelector("[data-pause]");
  const targetSelector = node.dataset.target || "";
  const targetElements = document.querySelectorAll(targetSelector);

  pauseElement.addEventListener("click", function () {
    pauseElement.style.display = "none";
    playElement.style.display = "flex";
    targetElements.forEach((el) => el.classList.add("pause-animation"));
  });

  playElement.addEventListener("click", function () {
    playElement.style.display = "none";
    pauseElement.style.display = "flex";
    targetElements.forEach((el) => el.classList.remove("pause-animation"));
  });
});
